export function stopNativeMediaPlayback(element: HTMLMediaElement) {
  try {
    element.pause();
  } catch {
    // jsdom / 受限浏览器环境可能不实现 pause 的完整行为。
  }
}

export function pauseNativeMediaElement(element: HTMLMediaElement) {
  stopNativeMediaPlayback(element);
  element.muted = true;
  element.volume = 0;
}

export function clearNativeMediaResource(element: HTMLMediaElement) {
  element.autoplay = false;
  element.removeAttribute('autoplay');
  try {
    element.srcObject = null;
  } catch {
    // 部分 jsdom / 旧浏览器环境不支持 srcObject setter。
  }
  element.removeAttribute('src');
  element.querySelectorAll('source').forEach((source) => {
    source.removeAttribute('src');
  });
  try {
    element.src = '';
  } catch {
    // 只要 attribute/source 已清掉即可；property 清理失败不阻断释放。
  }
  element.removeAttribute('src');
  element.load();
}

export function releaseNativeMediaElement(element: HTMLMediaElement) {
  pauseNativeMediaElement(element);
  clearNativeMediaResource(element);
}

export function releaseNativeMediaElementIfDetached(element: HTMLMediaElement) {
  releaseNativeMediaElementIfDetachedAfterPaint(element);
}

export function releaseNativeMediaElementIfDetachedAfterPaint(element: HTMLMediaElement) {
  pauseNativeMediaElement(element);
  const releaseIfDetached = () => {
    if (!element.isConnected) {
      clearNativeMediaResource(element);
    }
  };

  if (typeof window === 'undefined') {
    releaseIfDetached();
    return;
  }

  window.setTimeout(releaseIfDetached, 0);
}
